import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import getMenusService from 'services/menus';
import { MenuDataTypes, MenuItemDataTypes } from 'services/menus/types';
import { MENU_CODE } from 'utils/constants';
import groupMenus, {
  typePrefixGroupMenu,
} from 'utils/menu';

interface MenusState {
  header: MenuItemDataTypes[];
  groupedHeader: MenuItemDataTypes[];
  aboutUs: MenuItemDataTypes[];
  groupedAboutUs: MenuItemDataTypes[];
  menu: MenuItemDataTypes[];
  groupedFooterMenu: MenuItemDataTypes[];
  header2: MenuItemDataTypes[];
  menuIc: MenuItemDataTypes[];
  groupedMenuIc: MenuItemDataTypes[];
  menuOc: MenuItemDataTypes[];
  groupedMenuOc: MenuItemDataTypes[];
  menuIb: MenuItemDataTypes[];
  groupedMenuIb: MenuItemDataTypes[];
  menuTs: MenuItemDataTypes[];
  groupedMenuTs: MenuItemDataTypes[];
  menuNews: MenuItemDataTypes[];
  groupMenuNews: MenuItemDataTypes[];
  menuTi: MenuItemDataTypes[];
  menuFooter2: MenuItemDataTypes[];
  groupMenuFooter2: MenuItemDataTypes[];
  groupedHeaderCr: MenuItemDataTypes[];
  groupMenuFooterCr: MenuItemDataTypes[];
  loading?: boolean;
  error?: boolean;
}

const initialState: MenusState = {
  header: [],
  groupedHeader: [],
  aboutUs: [],
  groupedAboutUs: [],
  menu: [],
  groupedFooterMenu: [],
  header2: [],
  menuIc: [],
  groupedMenuIc: [],
  menuOc: [],
  groupedMenuOc: [],
  menuIb: [],
  groupedMenuIb: [],
  menuTs: [],
  groupedMenuTs: [],
  menuNews: [],
  groupMenuNews: [],
  menuTi: [],
  menuFooter2: [],
  groupMenuFooter2: [],
  groupedHeaderCr: [],
  groupMenuFooterCr: [],
  loading: false,
  error: false,
};

export const getMenusAction = createAsyncThunk<
  MenuDataTypes[],
  void,
  { rejectValue: ErrorResponse }
>('menusReducer/getMenusAction', async (_, { rejectWithValue }) => {
  try {
    return await getMenusService();
  } catch (error) {
    return rejectWithValue(error as ErrorResponse);
  }
});

export const menusSlice = createSlice({
  name: 'menusReducer',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder.addCase(getMenusAction.pending, ($state) => {
      $state.loading = true;
      $state.error = false;
    });
    builder.addCase(getMenusAction.rejected, ($state) => {
      $state.loading = false;
      $state.error = true;
    });
    builder.addCase(getMenusAction.fulfilled, ($state, action) => {
      $state.header = action.payload.find((item) => item.code === MENU_CODE.MENU_HEADER)
        ?.items || [];
      $state.groupedHeader = groupMenus(
        typePrefixGroupMenu(action.payload.find((item) => item.code === MENU_CODE.MENU_HEADER)
          ?.items),
      );
      $state.aboutUs = action.payload.find((item) => item.code === MENU_CODE.MENU_ABOUT_US)
        ?.items || [];
      $state.groupedAboutUs = groupMenus(
        typePrefixGroupMenu(
          action.payload.find((item) => item.code === MENU_CODE.MENU_ABOUT_US)?.items,
        ),
      );
      $state.menuIb = action.payload.find((item) => item.code === MENU_CODE.MENU_IB)
        ?.items || [];
      $state.groupedMenuIb = groupMenus(
        typePrefixGroupMenu(
          action.payload.find((item) => item.code === MENU_CODE.MENU_IB)
            ?.items,
        ),
      );
      $state.menu = action.payload.find((item) => item.code === MENU_CODE.MENU)?.items || [];
      $state.groupedFooterMenu = groupMenus(
        typePrefixGroupMenu(
          action.payload.find((item) => item.code === MENU_CODE.MENU)?.items,
        ),
      );
      $state.menuIc = action.payload.find((item) => item.code === MENU_CODE.MENU_IC)?.items || [];
      $state.groupedMenuIc = groupMenus(
        typePrefixGroupMenu(
          action.payload.find((item) => item.code === MENU_CODE.MENU_IC)?.items,
        ),
      );
      $state.header2 = groupMenus(
        action.payload.find((item) => item.code === MENU_CODE.MENU_HEADER_2)?.items,
      );
      $state.menuNews = action.payload.find((item) => item.code === MENU_CODE.MENU_NEWS)
        ?.items || [];
      $state.groupMenuNews = groupMenus(
        typePrefixGroupMenu(
          action.payload.find((item) => item.code === MENU_CODE.MENU_NEWS)?.items,
        ),
      );
      $state.menuOc = groupMenus(
        action.payload.find((item) => item.code === MENU_CODE.MENU_OC)?.items,
      );
      $state.groupedMenuOc = groupMenus(
        typePrefixGroupMenu(
          action.payload.find((item) => item.code === MENU_CODE.MENU_OC)
            ?.items,
        ),
      );
      $state.menuTs = action.payload.find((item) => item.code === MENU_CODE.MENU_TS)
        ?.items || [];
      $state.groupedMenuTs = groupMenus(
        typePrefixGroupMenu(
          action.payload.find((item) => item.code === MENU_CODE.MENU_TS)
            ?.items,
        ),
      );
      $state.menuTi = groupMenus(
        action.payload.find((item) => item.code === MENU_CODE.MENU_TI)
          ?.items,
      );
      $state.menuFooter2 = action.payload.find((item) => item.code === MENU_CODE.MENU_FOOTER_2)
        ?.items || [];
      $state.groupMenuFooter2 = groupMenus(
        typePrefixGroupMenu(action.payload.find((item) => item.code === MENU_CODE.MENU_FOOTER_2)
          ?.items),
      );
      $state.groupedHeaderCr = groupMenus(
        typePrefixGroupMenu(
          action.payload.find((item) => item.code === MENU_CODE.MENU_HEADER_CR)?.items,
        ),
      );
      $state.groupMenuFooterCr = groupMenus(
        typePrefixGroupMenu(action.payload.find((item) => item.code === MENU_CODE.MENU_FOOTER_CR)
          ?.items),
      );
      $state.loading = false;
      $state.error = false;
    });
  },
});

export default menusSlice.reducer;
